import { render } from "./PaymentCancelled.vue?vue&type=template&id=27324112&scoped=true"
import script from "./PaymentCancelled.vue?vue&type=script&lang=js"
export * from "./PaymentCancelled.vue?vue&type=script&lang=js"

import "./PaymentCancelled.vue?vue&type=style&index=0&id=27324112&lang=scss&scoped=true"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27324112"]])

export default __exports__